import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'productionGroups.title',
    defaultMessage: 'Cadastrar',
  },
})
